module.exports = __webpack_public_path__ + "static/img/jigou-beibuwan-bottom.1b11395.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-beibuwan-bottom.png
// module id = HroU
// module chunks = 2